<template lang="pug">
  .general
    .entity-content.pa-5
      v-row
        v-col.d-flex.align-center
            h2.primary--text {{$t('Shipment.general')}}
      v-row
        v-col.d-flex.align-center
            h3.primaryHover--text {{$t('Bundle.info')}}
      v-row
        v-col
          v-text-field(
              v-model="instance.key",
              :label="$t('Bundle.key')"
          )
        v-col
          v-select(
              :label="$t('Shipment.status')",
              :items="bundleStatuses",
              item-text="name",
              item-value="id",
              :loading="statusLoading",
              v-model="instance.statusId",
            )
        v-col
          app-datetime-picker(
            :value="instance.createdAt",
            :label="$t('Shipment.createdAt')",
            disabled,
          )
        v-col
          v-text-field(
            :value="instance.externalId",
            :label="$t('Shipment.externalId')",
            disabled,
          )
        v-col
          app-datetime-picker(
            :value="instance.modifiedAt",
            :label="$t('Shipment.modifiedAt')",
            disabled,
          )
      v-row
        v-col.py-0
          app-entity-relation(
            v-model="instance.businessScope",
            :parentInstance="instance"
            :relation = `entity.fields.find(f => f.name == "businessScope")`
            :showInfo="true"
            path="businessScope"
            :entity=`$searchEntity("BusinessScope", "name")`
            :parent="entity"
            @close="$emit('close')",
          )
    </template>
    
    <script>
    import EntityMixin from '@/mixins';
    import axios from 'axios';
    
    export default {
      mixins: [EntityMixin],
      props: {
        slotProps: null,
        entity: null,
        loading: null,
        errors: {
          type: Object,
          default: () => ({}),
        },
      },
      data: () => ({
        bundleStatuses: [],
        statusLoading: true,
      }),
      computed: {
      },
      async created() {
        try {
          this.bundleStatuses = (await axios.get('Status?where[]=entity="Bundle"', {params: { pageSize: -1 }})).data.data;
        } catch (e) {
          console.log(this.$cleanString(e))
        } finally {
          this.statusLoading = false;
        }
      },
    }
    </script>
    